import { useEffect } from "react";
import { captureAffiliateAttributionFromUrl } from "@/lib/affiliateAttribution";

export default function AffiliateAttributionLifecycle() {
  useEffect(() => {
    void captureAffiliateAttributionFromUrl();
  }, []);

  return null;
}
